<template>
  <article>
    <div class="filter mt-20">
      <div class="filter__item">
        <div class="filter__name">名字：</div>
        <el-input v-model="filters.nickname" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">用户ID：</div>
        <el-input v-model="filters.suid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">时间：</div>
        <el-date-picker v-model="filters.dateTime" type="datetimerange" placeholder="选择时间范围" align="right" size="mini" class="date">
        </el-date-picker>
      </div>
      <button class="blue-small-btn" @click="getList">搜索</button>
    </div>
    <div class="flex jcf mt-20">
      <button class="mr-10" :class="{'blue-small-btn': item.status, 'white-small-btn': !item.status}" v-for="(item, index) in levelList" :key="index" @click="changeLevel(index)">{{item.name}}</button>
    </div>
    <el-table :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="mt-30" height="600">
      <el-table-column prop="suid" label="用户ID" width="" align="center">
      </el-table-column>
      <el-table-column label="昵称" width="" align="center">
        <template slot-scope="scope">
          <router-link :to="{path: '/shopUserDetail', query: {suid: scope.row.suid}}">{{scope.row.nickname}}</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="头像" width="110" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.headimgurl" width="60" height="60">
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="电话号码" width="" align="center">
      </el-table-column>
      <el-table-column prop="level" label="等级" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="有效时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.effect_time)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="alipay_name" label="姓名" width="" align="center">
      </el-table-column>
      <el-table-column prop="alipay" label="支付宝" width="" align="center">
      </el-table-column>
      <el-table-column prop="income" label="总收入" width="" align="center">
      </el-table-column>
      <el-table-column prop="balance" label="余额" width="" align="center">
      </el-table-column>
      <el-table-column prop="exchange_num" label="兑换次数" width="" align="center">
      </el-table-column>
      <el-table-column prop="exchange_amount" label="兑换金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="son" label="徒弟" width="" align="center">
      </el-table-column>
      <el-table-column prop="grandson" label="徒孙" width="" align="center">
      </el-table-column>
      <el-table-column prop="offspring" label="增徒孙" width="" align="center">
      </el-table-column>
      <el-table-column prop="f_commission" label="师傅佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="gf_commission" label="师公佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="an_commission" label="师祖佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
  </article>
</template>

<script>
import mixinList from '../../../mixins/list'
import util from '../../../script/util'
import {shopUserLists, shopUserEdit} from '../../../api/api'
export default {
  name: 'shopUserList',
  mixins: [mixinList],
  data () {
    return {
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '正常',
          value: 1
        },
        {
          name: '封杀',
          value: 0
        }
      ],
      levelList: [
        {
          name: '所有',
          value: '1,2,3',
          status: 1
        },
        {
          name: 'v1',
          value: 1,
          status: 0
        },
        {
          name: 'v2',
          value: 2,
          status: 0
        },
        {
          name: 'v3',
          value: 3,
          status: 0
        }
      ],

      lists: [],
      listLoading: false,
      dialog: false,
      filters: {
        p: 1,
        l: 20,
        total: 0,
        level: '1,2,3',
        nickname: '',
        suid: '',
        dateTime: '',
        start_time: '',
        end_time: '',
        status: ''
      }
    }
  },
  methods: {
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    changeLevel (index) {
      this.levelList.forEach(item => {
        item.status = 0
      })
      this.levelList[index].status = 1
      this.filters.level = this.levelList[index].value
      this.filters.p = 1
      this.getList()
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }

      if (filters.level !== '') {
        params.level = filters.level
      }
      if (filters.nickname !== '') {
        params.nickname = filters.nickname
      }
      if (filters.suid !== '') {
        params.suid = filters.suid
      }
      if (filters.status !== '') {
        params.status = filters.status
      }
      if (filters.start_time !== '') {
        params.start_time = filters.start_time
      }
      if (filters.end_time !== '') {
        params.end_time = filters.end_time
      }
      this.listLoading = true
      shopUserLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          data.d.lists.forEach((item) => {
            item.isChoose = ''
          })
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    },
    changeUserinfo (index, oper) {
      let status = this.lists[index].status
      let suid = this.lists[index].suid

      if (oper === 2) {
        status = this.lists[index].status === 1 ? 0 : 1
      }

      let params = {
        status: status,
        suid: suid
      }
      shopUserEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    dateTimeChange () {
      if (this.filters.dateTime) {
        this.filters.start_time = parseInt(new Date(this.filters.dateTime[0]).getTime() / 1000)
        this.filters.end_time = parseInt(new Date(this.filters.dateTime[1]).getTime() / 1000)
      } else {
        this.filters.start_time = ''
        this.filters.end_time = ''
      }
    }
  },
  mounted () {
    this.getList()
  },
  watch: {
    'filters.dateTime': 'dateTimeChange',
    'filters.level': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/shop/shopAgentUserList.vue